import Vue from 'vue'
import * as option from "../config/options";
import Router from 'vue-router'

import index from '@/view/index'
import NotFound from '@/view/404'
import login from '@/view/login'

import timeLine from '@/view/基础数据管理/timeLine.vue'
import craftLine from '@/view/基础数据管理/craftLine.vue'
const homePage = r => require.ensure([], () => r(require('@/view/首页/首页.vue')), 'homePage');

//基础数据管理
const customerManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/客户管理.vue')), 'customerManagement');
const customerAdd = r => require.ensure([], () => r(require('@/view/基础数据管理/录入客户.vue')), 'customerAdd');
const customerEdit = r => require.ensure([], () => r(require('@/view/基础数据管理/编辑客户.vue')), 'customerEdit');
const groupManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/班组管理.vue')), 'groupManagement');
const groupAdd = r => require.ensure([], () => r(require('@/view/基础数据管理/新增班组.vue')), 'groupAdd');
const groupEdit = r => require.ensure([], () => r(require('@/view/基础数据管理/编辑班组.vue')), 'groupEdit');
const materialManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/材料管理.vue')), 'materialManagement');
const materialAdd = r => require.ensure([], () => r(require('@/view/基础数据管理/录入材料.vue')), 'materialAdd');
const materialEdit = r => require.ensure([], () => r(require('@/view/基础数据管理/编辑材料.vue')), 'materialEdit');
const supplierManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/供应商管理.vue')), 'supplierManagement');
const supplierAdd = r => require.ensure([], () => r(require('@/view/基础数据管理/录入供应商.vue')), 'supplierAdd');
const supplierEdit = r => require.ensure([], () => r(require('@/view/基础数据管理/编辑供应商.vue')), 'supplierEdit');
const deviceManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/设备管理.vue')), 'deviceManagement');
const deviceAdd = r => require.ensure([], () => r(require('@/view/基础数据管理/录入设备.vue')), 'deviceAdd');
const deviceEdit = r => require.ensure([], () => r(require('@/view/基础数据管理/编辑设备.vue')), 'deviceEdit');
const mouldManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/模具工装管理.vue')), 'mouldManagement');
const mouldAdd = r => require.ensure([], () => r(require('@/view/基础数据管理/录入模具工装.vue')), 'mouldAdd');
const mouldType = r => require.ensure([], () => r(require('@/view/基础数据管理/模具工装类型管理.vue')), 'mouldType');
const mouldEdit = r => require.ensure([], () => r(require('@/view/基础数据管理/编辑模具工装.vue')), 'mouldEdit');
const positionManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/工位管理.vue')), 'positionManagement');
const positionAdd = r => require.ensure([], () => r(require('@/view/基础数据管理/录入工位信息.vue')), 'positionAdd');
const positionEdit = r => require.ensure([], () => r(require('@/view/基础数据管理/编辑工位信息.vue')), 'positionEdit');
const notificationManagement = r => require.ensure([], () => r(require('@/view/基础数据管理/通知管理.vue')), 'notificationManagement');
const noticeRecord = r => require.ensure([], () => r(require('@/view/基础数据管理/通知记录.vue')), 'noticeRecord');
// const creationList = r => require.ensure([], () => r(require('@/view/基础数据管理/生产物管理.vue')), 'creationList');

//订单管理
const orderList = r => require.ensure([], () => r(require('@/view/订单管理/订单列表.vue')), 'orderList');
const orderAdd = r => require.ensure([], () => r(require('@/view/订单管理/录入订单.vue')), 'orderAdd');
const orderEdit = r => require.ensure([], () => r(require('@/view/订单管理/编辑订单.vue')), 'orderEdit');
const orderSplit = r => require.ensure([], () => r(require('@/view/订单管理/拆分订单.vue')), 'orderSplit');
const orderAudit = r => require.ensure([], () => r(require('@/view/订单管理/订单审核.vue')), 'orderAudit');
const orderRecord = r => require.ensure([], () => r(require('@/view/订单管理/订单修改记录.vue')), 'orderRecord');

//采购管理
const purchaseList = r => require.ensure([], () => r(require('@/view/采购管理/采购需求单列表.vue')), 'purchaseList');
const changePrice = r => require.ensure([], () => r(require('@/view/采购管理/申请价格更改.vue')), 'changePrice');

//产品及工艺管理
const productList = r => require.ensure([], () => r(require('@/view/产品及工艺管理/产品列表.vue')), 'productList');
const productAdd = r => require.ensure([], () => r(require('@/view/产品及工艺管理/产品录入.vue')), 'productAdd');
const productEdit = r => require.ensure([], () => r(require('@/view/产品及工艺管理/编辑产品.vue')), 'productEdit');
const productMaintenance = r => require.ensure([], () => r(require('@/view/产品及工艺管理/产品及工序维护.vue')), 'productMaintenance');
const routeDetail = r => require.ensure([], () => r(require('@/view/产品及工艺管理/查看工艺路线.vue')), 'routeDetail');
const routeAdd = r => require.ensure([], () => r(require('@/view/产品及工艺管理/新增工艺路线.vue')), 'routeAdd');
const routeEdit = r => require.ensure([], () => r(require('@/view/产品及工艺管理/编辑工艺路线.vue')), 'routeEdit');
const categoryManagement = r => require.ensure([], () => r(require('@/view/产品及工艺管理/工序类别管理.vue')), 'categoryManagement');
const categoryAdd = r => require.ensure([], () => r(require('@/view/产品及工艺管理/新增类别.vue')), 'categoryAdd');
const categoryEdit = r => require.ensure([], () => r(require('@/view/产品及工艺管理/类别编辑.vue')), 'categoryEdit');
const badRecordList = r => require.ensure([], () => r(require('@/view/产品及工艺管理/不良记录.vue')), 'badRecord');
const badRecordDetail = r => require.ensure([], () => r(require('@/view/产品及工艺管理/查看不良记录.vue')), 'badRecordDetail');
const processTime = r => require.ensure([], () => r(require('@/view/产品及工艺管理/工序用时统计.vue')), 'processTime');
const processTimeEdit = r => require.ensure([], () => r(require('@/view/产品及工艺管理/更新工序用时数据.vue')), 'processTimeEdit');

//生产任务管理
const productionDemandList = r => require.ensure([], () => r(require('@/view/生产任务管理/生产需求单列表.vue')), 'productionDemandList');
const orderSchedulingManagement = r => require.ensure([], () => r(require('@/view/生产任务管理/订单排期管理.vue')), 'orderSchedulingManagement');
const productionTaskRelease = r => require.ensure([], () => r(require('@/view/生产任务管理/生产任务发布管理.vue')), 'productionTaskRelease');
const productionTaskReleaseCopy = r => require.ensure([], () => r(require('@/view/生产任务管理/生产任务发布管备份.vue')), 'productionTaskReleaseCopy');
const productionDemandAdd = r => require.ensure([], () => r(require('@/view/生产任务管理/新增生产需求单.vue')), 'productionDemandAdd');
const mouldtoolsTaskRelease = r => require.ensure([], () => r(require('@/view/生产任务管理/装拆模任务管理.vue')), 'mouldtoolsTaskRelease');
const mouldtoolsTaskAdd = r => require.ensure([], () => r(require('@/view/生产任务管理/分配装拆模任务.vue')), 'mouldtoolsTaskAdd');
const productionTaskStatistics = r => require.ensure([], () => r(require('@/view/生产任务管理/生产任务统计.vue')), 'productionTaskStatistics');
const productiontest = r => require.ensure([], () => r(require('@/view/生产任务管理/生产任务发布管备份.vue')), 'productiontest');
const productionDemandLogList = r => require.ensure([], () => r(require('@/view/生产任务管理/生产需求单修改记录.vue')), 'productionDemandLogList');
const creationAdminList = r => require.ensure([], () => r(require('@/view/生产任务管理/生产移交记录.vue')), 'creationAdminList');
const wageStatistics = r => require.ensure([], () => r(require('@/view/生产任务管理/员工工资统计.vue')), 'wageStatistics');

//质检管理
const inspectorList = r => require.ensure([], () => r(require('@/view/质检管理/质检员列表.vue')), 'inspectorList');
const inspectionManagement = r => require.ensure([], () => r(require('@/view/质检管理/质检管理.vue')), 'inspectionManagement');
const inspectionPlanList = r => require.ensure([], () => r(require('@/view/质检管理/质检方案列表.vue')), 'inspectionPlanList');
const configurationAuthority = r => require.ensure([], () => r(require('@/view/质检管理/质检员权限配置.vue')), 'configurationAuthority');
const inspectionPlanAdd = r => require.ensure([], () => r(require('@/view/质检管理/新建质检方案.vue')), 'inspectionPlanAdd');
const inspectionPlanEdit = r => require.ensure([], () => r(require('@/view/质检管理/编辑质检方案.vue')), 'inspectionPlanEdit');

//仓库管理
const purchaseAndStorage = r => require.ensure([], () => r(require('@/view/仓库管理/采购入库管理.vue')), 'purchaseAndStorage');
const productionWarehousing = r => require.ensure([], () => r(require('@/view/仓库管理/生产入库管理.vue')), 'productionWarehousing');
const deliveryAndOutgoing = r => require.ensure([], () => r(require('@/view/仓库管理/发货出库管理.vue')), 'deliveryAndOutgoing');
const productionMaterial = r => require.ensure([], () => r(require('@/view/仓库管理/生产领料管理.vue')), 'productionMaterial');
const materialInventory = r => require.ensure([], () => r(require('@/view/仓库管理/材料库存管理.vue')), 'materialInventory');
const shelfManagement = r => require.ensure([], () => r(require('@/view/仓库管理/货架管理.vue')), 'shelfManagement');
const regionalManagement = r => require.ensure([], () => r(require('@/view/仓库管理/区域管理.vue')), 'regionalManagement');
const inventoryManagement = r => require.ensure([], () => r(require('@/view/仓库管理/盘库任务管理.vue')), 'inventoryManagement');
const shelvesAdd = r => require.ensure([], () => r(require('@/view/仓库管理/新增货架.vue')), 'shelvesAdd');
const areaAdd = r => require.ensure([], () => r(require('@/view/仓库管理/新增区域.vue')), 'areaAdd');
const libraryAdd = r => require.ensure([], () => r(require('@/view/仓库管理/新增盘库.vue')), 'libraryAdd');
const shelvesEdit = r => require.ensure([], () => r(require('@/view/仓库管理/编辑货架.vue')), 'shelvesEdit');
const areaEdit = r => require.ensure([], () => r(require('@/view/仓库管理/编辑区域.vue')), 'areaEdit');

//财务管理
const paymentMoneyAudit = r => require.ensure([], () => r(require('@/view/财务管理/到款审核管理.vue')), 'paymentMoneyAudit');
const paymentAudit = r => require.ensure([], () => r(require('@/view/财务管理/付款审核管理.vue')), 'paymentAudit');
const inventoryAuditManagement = r => require.ensure([], () => r(require('@/view/财务管理/盘库审核管理.vue')), 'inventoryAuditManagement');
const rawMaterialPriceAudit = r => require.ensure([], () => r(require('@/view/财务管理/原材料价格审核.vue')), 'rawMaterialPriceAudit');

//系统管理
const employeeManagement = r => require.ensure([], () => r(require('@/view/系统管理/员工管理.vue')), 'employeeManagement');
const roleManagement = r => require.ensure([], () => r(require('@/view/系统管理/角色管理.vue')), 'roleManagement');
const employeeAdd = r => require.ensure([], () => r(require('@/view/系统管理/新增员工.vue')), 'employeeAdd');
const roleAdd = r => require.ensure([], () => r(require('@/view/系统管理/新增角色.vue')), 'roleAdd');
const employeeEdit = r => require.ensure([], () => r(require('@/view/系统管理/编辑员工.vue')), 'employeeEdit');
const roleEdit = r => require.ensure([], () => r(require('@/view/系统管理/编辑角色.vue')), 'roleEdit');


Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '',
      redirect: '/login',
      hidden: true
    },
    {
      path: '/404',
      component: NotFound,
      name: '',
      hidden: true
    },
    {
      path: '/login',
      component: login,
      name: '登录',
      hidden: true
    },
    {
      path: '/',
      component: index,
      name: '首页',
      hidden: false,
      leaf: true,
      permission:'base_data_manager',
      icon: '',//图标样式class
      children: [
        {
          path: '/homePage', component: homePage, name: '我的信息',
        },
      ]
    },
    {
      path: '/',
      component: index,
      name: '基础数据管理',
      hidden: false,
      leaf: false,
      permission:'base_data_manager',
      icon: 'iconfont icon-shuju',//图标样式class
      children: [
        {
          path: '/timeLine', component: timeLine, name: '时间',
        },
        {
          path: '/craftLine', component: craftLine, name: '工艺路线',
        },
        {
          path: '/customerManagement', component: customerManagement, name: '客户管理', permission:'client_manager'
        },
        {
          path: '/customerAdd', component: customerAdd, name: '录入客户', hidden: true, permission:'client_add', _path: '/customerManagement'
        },
        {
          path: '/customerEdit', component: customerEdit, name: '编辑客户', hidden: true, permission:'client_edit', _path: '/customerManagement'
        },
        {
          path: '/groupManagement', component: groupManagement, name: '班组管理', permission:'teams_manager'
        },
        {
          path: '/groupAdd', component: groupAdd, name: '新增班组', hidden: true, permission:'teams_add', _path: '/groupManagement'
        },
        {
          path: '/groupEdit', component: groupEdit, name: '编辑班组', hidden: true,permission:'teams_edit', _path: '/groupManagement'
        },
        {
          path: '/materialManagement', component: materialManagement, name: '材料管理',permission:'materials_manager'
        },
        {
          path: '/materialAdd', component: materialAdd, name: '录入材料', hidden: true,permission:'materials_add', _path: '/materialManagement'
        },
        {
          path: '/materialEdit', component: materialEdit, name: '编辑材料', hidden: true,permission:'materials_edit', _path: '/materialManagement'
        },
        {
          path: '/supplierManagement', component: supplierManagement, name: '供应商管理',permission:'suppliers_manager'
        },
        {
          path: '/supplierAdd', component: supplierAdd, name: '录入供应商', hidden: true,permission:'suppliers_add', _path: '/supplierManagement'
        },
        {
          path: '/supplierEdit', component: supplierEdit, name: '编辑供应商', hidden: true,permission:'suppliers_edit', _path: '/supplierManagement'
        },
        {
          path: '/deviceManagement', component: deviceManagement, name: '设备管理',permission:'equipment_manager'
        },
        {
          path: '/deviceAdd', component: deviceAdd, name: '录入设备', hidden: true, permission:'equipment_add', _path: '/deviceManagement'
        },
        {
          path: '/deviceEdit', component: deviceEdit, name: '编辑设备', hidden: true, permission:'equipment_edit', _path: '/deviceManagement'
        },
        {
          path: '/mouldManagement', component: mouldManagement, name: '模具工装管理', permission:'tool_manager'
        },
        {
          path: '/mouldAdd', component: mouldAdd, name: '录入模具工装', hidden: true, permission:'tools_add', _path: '/mouldManagement'
        },
        {
          path: '/mouldType', component: mouldType, name: '模具工装类型管理', hidden: true, permission:'tools_add', _path: '/mouldManagement'
        },
        {
          path: '/mouldEdit', component: mouldEdit, name: '编辑模具工装', hidden: true, permission:'tools_edit', _path: '/mouldManagement'
        },
        {
          path: '/positionManagement', component: positionManagement, name: '工位管理', permission:'station_manager'
        },
        {
          path: '/positionAdd', component: positionAdd, name: '录入工位信息', hidden: true, permission:'station_add', _path: '/positionManagement'
        },
        {
          path: '/positionEdit', component: positionEdit, name: '编辑工位信息', hidden: true, permission:'station_edit', _path: '/positionManagement'
        },
        {
          path: '/notificationManagement', component: notificationManagement, name: '通知管理',permission:'notify_manager'
        },
        {
          path: '/noticeRecord', component: noticeRecord, name: '通知记录', hidden: true, permission:'notify_record_list'
        },
        // {
        //   path: '/creationList', component: creationList, name: '生产物管理', permission:'creation_list'
        // },
      ]
    },
    {
      path: '/',
      component: index,
      name: '产品及工艺管理',
      hidden: false,
      leaf: false,
      permission:'product_manager',
      icon: 'iconfont icon-chanpin',//图标样式class
      children: [
        {
          path: '/productList', component: productList, name: '产品列表', permission:'product_list',
        },
        {
          path: '/productAdd', component: productAdd, name: '新增产品信息', hidden: true, permission:'product_add', _path: '/productList'
        },
        {
          path: '/productEdit', component: productEdit, name: '编辑产品信息', hidden: true, permission:'product_edit', _path: '/productList'
        },
        {
          path: '/productMaintenance', component: productMaintenance, name: '产品及工序维护', permission:'process_list',
        },
        {
          path: '/routeDetail', component: routeDetail, name: '工艺路线详情', hidden: true, permission:'procument_detail',
        },
        {
          path: '/routeAdd', component: routeAdd, name: '新增工艺路线', hidden: true, permission:'procument_add',
        },
        {
          path: '/routeEdit', component: routeEdit, name: '编辑工艺路线', hidden: true, permission:'procument_edit',
        },
        {
          path: '/categoryManagement', component: categoryManagement, name: '工序类别管理', permission:'category_list',
        },
        {
          path: '/categoryAdd', component: categoryAdd, name: '新增类别', hidden: true, permission:'category_add', _path: '/categoryManagement'
        },
        {
          path: '/categoryEdit', component: categoryEdit, name: '类别编辑', hidden: true, permission:'category_edit', _path: '/categoryManagement'
        },
        {
          path: '/badRecord', component: badRecordList, name: '不良记录', permission:'bad_record_edit'
        },
        {
          path: '/badRecordDetail', component: badRecordDetail, name: '查看不良记录', hidden: true, permission:'bad_record_edit', _path: '/badRecord'
        },
        {
          path: '/processTime', component: processTime, name: '工序用时统计', permission:'procedure_stats_edit',  // procedure_stats_edit
        },
        {
          path: '/processTimeEdit', component: processTimeEdit, name: '编辑工序用时统计', hidden: true, permission:'procedure_stats_edit',  // procedure_stats_edit
        },
      ]
    },
    {
      path: '/',
      component: index,
      name: '订单管理',
      hidden: false,
      leaf: false,
      permission:'orders_manager',
      icon: 'iconfont icon-dingdanguanli',//图标样式class
      children: [
        {
          path: '/orderList', component: orderList, name: '订单列表', permission:'orders_list',
        },
        {
          path: '/orderAdd', component: orderAdd, name: '录入订单', hidden: true, permission:'orders_add',
        },
        {
          path: '/orderEdit', component: orderEdit, name: '编辑订单', hidden: true, permission:'orders_edit',
        },
        {
          path: '/orderSplit', component: orderSplit, name: '拆分订单', hidden: true, permission:'orders_split',
        },
        {
          path: '/orderAudit', component: orderAudit, name: '订单审核', permission:'orders_check_list',
        },
        {
          path: '/orderRecord', component: orderRecord, name: '订单修改记录', permission:'orders_check_list',
        },
        // {
        //   path: '/orderRecord', component: orderRecord, name: '订单修改记录', permission:'orders_record_list',
        // },
      ]
    },
    {
      path: '/',
      component: index,
      name: '质检管理',
      hidden: false,
      leaf: false,
      permission:'quality_manager',
      icon: 'iconfont icon-zhijianluyin',//图标样式class
      children: [
        {
          path: '/inspectorList', component: inspectorList, name: '质检员列表', permission:'quality_people_list',
        },
        {
          path: '/inspectionManagement', component: inspectionManagement, name: '质检任务列表', permission:'quality_task_list',
        },
        {
          path: '/inspectionPlanList', component: inspectionPlanList, name: '质检方案列表',permission:'quality_programme_list',
        },
        {
          path: '/configurationAuthority', component: configurationAuthority, name: '质检员权限配置', hidden:true, permission:'quality_people_edit',
        },
        {
          path: '/inspectionPlanAdd', component: inspectionPlanAdd, name: '新建质检方案',hidden:true, permission:'quality_programme_add',
        },
        {
          path: '/inspectionPlanEdit', component: inspectionPlanEdit, name: '编辑质检方案',hidden:true, permission:'quality_programme_edit',
        },

      ]
    },
    {
      path: '/',
      component: index,
      name: '生产任务管理',
      hidden: false,
      leaf: false,
      permission:'production_task_manager',
      icon: 'iconfont icon-renwuliebiao',//图标样式class
      children: [
        {
          path: '/productionDemandList', component: productionDemandList, name: '生产需求单列表', permission:'production_demand_list',
        },
        {
          path: '/orderSchedulingManagement', component: orderSchedulingManagement, name: '订单排期管理', permission:'orders_time_list',
        },
        // {
        //         //   path: '/productionTaskRelease', component: productionTaskRelease, name: '分配生产任务', permission:'task_submit_manager',
        //         // },
        {
          path: '/productionTaskReleaseCopy', component: productionTaskReleaseCopy, name: '分配生产任务', permission:'task_submit_manager',
        },
        {
          path: '/mouldtoolsTaskRelease', component: mouldtoolsTaskRelease, name: '装拆模任务分配', permission:'task_submit_manager',
        },
        {
          path: '/mouldtoolsTaskAdd', component: mouldtoolsTaskAdd, name: '分配装拆模任务',hidden:true, permission:'task_submit_manager',
        },
        {
          path: '/productionDemandAdd', component: productionDemandAdd, name: '新增生产需求单',hidden:true, permission:'production_demand_add',
        },
        {
          path: '/productionTaskStatistics', component: productionTaskStatistics, name: '生产任务统计', permission:'production_demand_detail',
        },
        {
          path: '/productiontest', component: productiontest, name: '测试',
        },
        {
          path: '/productionDemandLogList', component: productionDemandLogList, hidden:true, name: '生产需求单修改记录', permission:'product_task_log_list',
        },
        {
          path: '/creationAdminList', component: creationAdminList, name: '生产移交记录', permission:'creation_admin_List',
        },
        {
          path: '/wageStatistics', component: wageStatistics, name: '员工工资统计', permission:'production_salary',
        },
      ]
    },
    {
      path: '/',
      component: index,
      name: '采购管理',
      hidden: false,
      leaf: false,
      permission:'procurement_manager',
      icon: 'iconfont icon-caigoudanguanli',//图标样式class
      children: [
        {
          path: '/purchaseList', component: purchaseList, name: '采购需求单列表', permission:'procurement_orders_list',
        },
        {
          path: '/changePrice', component: changePrice, name: '申请更改原料价格',hidden:true, permission:'procurement_price_change',
        },
      ]
    },
    {
      path: '/',
      component: index,
      name: '仓库管理',
      hidden: false,
      leaf: false,
      permission:'house_manager',
      icon: 'iconfont icon-beipin_cangkuguanli',//图标样式class
      children: [
        {
          path: '/purchaseAndStorage', component: purchaseAndStorage, name: '采购入库管理', permission:'buy_enter_manager',
        },
        {
          path: '/productionWarehousing', component: productionWarehousing, name: '生产入库管理', permission:'production_enter_manager',
        },
        {
          path: '/deliveryAndOutgoing', component: deliveryAndOutgoing, name: '发货出库管理', permission:'send_out_manager',
        },
        {
          path: '/productionMaterial', component: productionMaterial, name: '生产领料管理',permission:'product_task_manager',
        },
        {
          path: '/materialInventory', component: materialInventory, name: '材料库存管理',permission:'materials_cargo_manager',
        },
        {
          path: '/shelfManagement', component: shelfManagement, name: '货架管理',permission:'storage_rack_manager',
        },
        {
          path: '/regionalManagement', component: regionalManagement, name: '区域管理',permission:'area_manager',
        },
        {
          path: '/inventoryManagement', component: inventoryManagement, name: '盘库任务管理',permission:'stocktake_task_manager',
        },
        {
          path: '/shelvesAdd', component: shelvesAdd, name: '新增货架',hidden:true, permission:'storage_rack_add',
        },
        {
          path: '/areaAdd', component: areaAdd, name: '新增区域',hidden:true, permission:'area_add',
        },
        {
          path: '/libraryAdd', component: libraryAdd, name: '新增盘库',hidden:true, permission:'stocktake_add',
        },
        {
          path: '/shelvesEdit', component: shelvesEdit, name: '编辑货架',hidden:true, permission:'storage_rack_edit',
        },
        {
          path: '/areaEdit', component: areaEdit, name: '编辑区域',hidden:true, permission:'area_edit',
        },
      ]
    },
    {
      path: '/',
      component: index,
      name: '财务管理',
      hidden: false,
      leaf: false,
      permission:'finance_manager',
      icon: 'iconfont icon-caiwuguanli',//图标样式class
      children: [
        {
          path: '/paymentMoneyAudit', component: paymentMoneyAudit, name: '到款审核管理', permission:'orders_plan_manage',
        },
        {
          path: '/paymentAudit', component: paymentAudit, name: '付款审核管理', permission:'orders_payment_manager',
        },
        {
          path: '/inventoryAuditManagement', component: inventoryAuditManagement, name: '盘库审核管理', permission:'stocktake_check_manager',
        },
        {
          path: '/rawMaterialPriceAudit', component: rawMaterialPriceAudit, name: '原材料价格审核', permission:'materials_check_manager',
        },
      ]
    },
    {
      path: '/',
      component: index,
      name: '系统管理',
      hidden: false,
      leaf: false,
      permission:'system_manager',
      icon: 'iconfont icon-xitongguanli',//图标样式class
      children: [
        {
          path: '/employeeManagement', component: employeeManagement, name: '员工管理', permission:'admin_manager',
        },
        {
          path: '/roleManagement', component: roleManagement, name: '角色管理', permission:'role_manager',
        },
        {
          path: '/employeeAdd', component: employeeAdd, name: '新增员工',hidden:true, permission:'admin_add',
        },
        {
          path: '/roleAdd', component: roleAdd, name: '新增角色',hidden:true, permission:'role_add',
        },
        {
          path: '/employeeEdit', component: employeeEdit, name: '编辑员工',hidden:true, permission:'admin_edit',
        },
        {
          path: '/roleEdit', component: roleEdit, name: '编辑角色',hidden:true, permission:'role_edit',
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js